import enUS from '@/i18n/lang/en-US'
import esMX from '@/i18n/lang/es-MX'
import VueI18n from 'vue-i18n'
import { lang, transfromAll } from '../lang'
import Vue from 'vue'

const messages = {
  'en-US': transfromAll(enUS),
  'es-MX': transfromAll(esMX)
}

Vue.use(VueI18n)

export const i18n = new VueI18n({
  messages,
  locale: lang,
})

export const useI18n = () => {
  return i18n
}